import React, { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    IStackTokens,
    Stack,
    StackItem,
    TextField,
    ITextFieldProps,
    IRenderFunction,
    Icon,
    Dialog,
    DialogType,
    DialogFooter,
    IDatePicker,
    DatePicker, defaultDatePickerStrings, Label,
    MessageBar, MessageBarType
} from "@fluentui/react";
import { TooltipHost, ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import strings from "../../../loc/strings";
import { UpdatePOIById, CreatePersonOfInterest, CreateAssessment, ConvertForIndex, UpdateIndexRecord } from "../../../services/ManageSystemServices/POIService";
import { POIItem } from "../../../model/ManagePOIListItem";
import { AssessmentItem } from "../../../model/ManagePOIListItem";
import { LEGAL_PERSON_TYPE, NATURAL_PERSON_TYPE } from "../../../constants/EiopaFnPConstants";
import { fetchEUSLB } from "../../../services/AdminServices/EUSLBService";
import { getUserInfo } from "../../../services/UserInfoService";
import { EIOPAError } from "../../../model/EIOPAError";
import { validateObject, getFormattedInvalidCharacters } from "../../../services/AppSettingsService";

const onFormatDate = (date?: Date): string => {
    if (date) {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let dayString = day < 10 ? '0' + day.toString() : day.toString();
        let monthString = month < 10 ? '0' + month.toString() : month.toString();

        return dayString + '/' + monthString + '/' + date.getFullYear();
    }

    return '';
}

const type: IDropdownOption[] = [
    { key: NATURAL_PERSON_TYPE, text: "Natural" },
    { key: LEGAL_PERSON_TYPE, text: "Legal" },
];

const stackTokens: IStackTokens = { childrenGap: 20 };

const calloutProps = { gapSpace: 0 };
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block', margin: '0px 0px -3px 0px!important' } };

const onRenderLabelHandleIDNo: IRenderFunction<ITextFieldProps> = (props, defaultRender): JSX.Element => {
    return (
        <>
            <Stack horizontal verticalAlign="center" tokens={stackTokens}>
                {defaultRender && defaultRender(props)}
                <TooltipHost
                    content="When ID number is provided mandatory fields are altered."
                    id="Info"
                    className={styles.info}
                    calloutProps={calloutProps}
                    styles={hostStyles}
                >
                    <Icon iconName="Info" aria-label="Info" className={styles.infoIcon} />
                </TooltipHost>
            </Stack>
        </>
    );
};

const onRenderLabelHandleSSN: IRenderFunction<ITextFieldProps> = (props, defaultRender): JSX.Element => {
    return (
        <>
            <Stack horizontal verticalAlign="center" tokens={stackTokens}>
                {defaultRender && defaultRender(props)}
                <TooltipHost
                    content="When Social security number is provided mandatory fields are altered."
                    id="Info2"
                    className={styles.info}
                    calloutProps={calloutProps}
                    styles={hostStyles}
                >
                    <Icon iconName="Info" aria-label="Info2" className={styles.infoIcon} />
                </TooltipHost>
            </Stack>
        </>
    );
};

function AddEditDialog(props: any) {
    const auth = useAuth();

    const initialPOI = {
        "id": undefined,
        "encryptedId": undefined,
        "personTypeID": NATURAL_PERSON_TYPE,
        "firstName": null,
        "lastName": null,
        "legalName": null,
        "alsoKnownAs": null,
        "dateOfBirth": null,
        "cityOfBirth": null,
        "countryOfBirth": null,
        "leI_Registration": null,
        "countryInc": null,
        "createdDate": new Date().toISOString(),
        "createdBy": auth.user?.profile.email,
        "markedForDeletionDate": null,
        "idNumber": null,
        "socialSecurityNumber": null,
        "assessments": null,
    };

    const initialAssessment = {
        "id": undefined,
        "personId": props.POIId,
        "assessingCAId": null,
        "internalCARefNo": null,
        "euSectoralLegislatureBasisId": null,
        "euSectoralLegislatureBasis": null,
        "dateOfAssessment": new Date().toLocaleDateString('fr-BE'),
        "createdDate": new Date().toISOString(),
        "createdBy": auth.user?.profile.email,
        "markedForDeletionDate": null,
    }

    const [addEditItem, setAddEditItem] = React.useState<POIItem>({ ...initialPOI });
    const [addAssessmentItem, setAddAssessmentItem] = React.useState<AssessmentItem>({ ...initialAssessment });
    const [showHistoricalFields, setShowHistoricalFields] = useState(false);

    useEffect(() => {
        if (props.item && Object.keys(props.item).length > 0)
            setAddEditItem({ ...props.item });
    }, [props.item]);

    useEffect(() => {
        setShowHistoricalFields(!props.isHistoricalPeriodEnded ||
            (!props.isAdd && props.item && (props.item.idNumber || props.item.socialSecurityNumber)));
    }, [props.isHistoricalPeriodEnded, props.isAdd, props.item ]);

    const handleSubmit = (event: any) => {
        event.preventDefault();
    }

    let userInfo = getUserInfo(auth.user?.id_token);

    const resetField = () => {
        setAddEditItem({ ...initialPOI });
        setAddAssessmentItem({ ...initialAssessment });
    }

    const handleDialogClose = () => {
        props.setDialogIsHidden(true);
        resetField();
        setError('');
    };
    const [error, setError] = useState('');
    const [dateOfBirthIsValid, setDateOfBirthIsValid] = useState(false);
    const [dateOfBirthIsRequired, setDateOfBirthIsRequired] = useState(true);
    const [dateOfAssessmentIsValid, setDateOfAssessmentIsValid] = useState(true);

    const handleDialogSave = (id: number, item: POIItem) => {
        let flag = false;
        console.log('dateIsValid', dateOfBirthIsValid, 'required', dateOfBirthIsRequired);
        if (item.personTypeID == NATURAL_PERSON_TYPE) {
            if (!((item.firstName && item.lastName && dateOfBirthIsValid && (item.idNumber || item.socialSecurityNumber)) || (item.firstName && item.lastName && item.dateOfBirth && dateOfBirthIsValid && item.countryOfBirth && item.cityOfBirth))) {
                setError('Add the Required fields.');
            } else {
                setError('');
                flag = true;
            }
        } else if (item.personTypeID == LEGAL_PERSON_TYPE) {
            if (item.legalName === '' || item.legalName === undefined || item.legalName === null) {
                setError('Add Legal name');
            } else if (item.leI_Registration === '' || item.leI_Registration === undefined || item.leI_Registration === null) {
                setError('Add LEI / Registration number');
            } else {
                flag = true;
                setError('');
            }
        }

        // Validate for invalid characters
        if (flag && !validateObject(item)) {
            const invalidChars = getFormattedInvalidCharacters();
            setError(`Illegal HTML content - please remove any of the following special characters: ${invalidChars}`);
            flag = false;
        }

        if (flag) {
            if (id != 0) {
                Object.keys(item).forEach((k) => item[k as keyof POIItem] === "" && delete item[k as keyof POIItem]);
                UpdatePOIById(item.encryptedId, item, auth.user?.id_token).then((response) => {
                    // Successful update, handle the response accordingly
                    console.log('Person Of Interest item updated successfully:', typeof response === 'object' && Object.keys(response).length > 0);
                    // Update the user interface, refresh the data list, etc.
                    if (typeof response === 'object' && Object.keys(response).length > 0) {
                        handleIndex(response);
                        props.handleActionResponse('poiedittrue');
                        handleDialogClose();
                        resetField();
                    } else {
                        if (response == 'The edited POI already exists in the system') {
                            console.error('Error updating Person Of Interest item:', response);
                            props.handleActionResponse('poieditexist');
                            handleDialogClose();
                            resetField();
                        } else {
                            let serverErrorMessage = strings.POIDefaultErrorMessage;

                            try {
                                const parsed = JSON.parse(response);
                                if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                    serverErrorMessage = parsed.errors[0];
                                } else {
                                    serverErrorMessage = response;
                                }
                            } catch {
                                serverErrorMessage = response;
                            }

                            props.handleActionResponse('error', serverErrorMessage);

                            handleDialogClose();
                            resetField();
                        }
                    }
                }).catch((error) => {
                    // If there is an error during update, handle it
                    console.error('Error updating Person Of Interest item:', error);

                    // Try to extract a meaningful error message if possible
                    if (error instanceof Error) {
                        props.handleActionResponse('error', error.message);
                    } else if (typeof error === 'string') {
                        props.handleActionResponse('error', error);
                    } else {
                        // Fall back to generic error if we can't extract a specific message
                        props.handleActionResponse('poieditfalse');
                    }

                    handleDialogClose();
                    resetField();
                });
            }
            else {
                if (addAssessmentItem.dateOfAssessment === null || !dateOfAssessmentIsValid) {
                    setError('Add Date of assessment');
                } else if (addAssessmentItem.euSectoralLegislatureBasisId === null) {
                    setError('Add EU sectoral legislative basis');
                } else {
                    if (item.personTypeID === NATURAL_PERSON_TYPE) {
                        item.countryInc = null;
                        item.leI_Registration = null;
                        item.legalName = null;
                    }
                    else {
                        item.cityOfBirth = null;
                        item.countryOfBirth = null;
                        item.dateOfBirth = null;
                        item.firstName = null;
                        item.idNumber = null;
                        item.lastName = null;
                        item.socialSecurityNumber = null;
                    }

                    // Validate for invalid characters in POI item
                    if (!validateObject(item)) {
                        const invalidChars = getFormattedInvalidCharacters();
                        setError(`Illegal HTML content - please remove any of the following special characters: ${invalidChars}`);
                        return;
                    }

                    // Validate for invalid characters in Assessment item
                    if (!validateObject(addAssessmentItem)) {
                        const invalidChars = getFormattedInvalidCharacters();
                        setError(`Illegal HTML content - please remove any of the following special characters: ${invalidChars}`);
                        return;
                    }

                    Object.keys(item).forEach((k) => item[k as keyof POIItem] === null && delete item[k as keyof POIItem]);
                    Object.keys(item).forEach((k) => item[k as keyof POIItem] === undefined && delete item[k as keyof POIItem]);
                    Object.keys(item).forEach((k) => item[k as keyof POIItem] === "" && delete item[k as keyof POIItem]);
                    setAddEditItem(item);
                    CreatePersonOfInterest(item, auth.user?.id_token).then((response) => {
                        // Successful create, handle the response accordingly
                        console.log('Person Of Interest item created successfully:', typeof response === 'object' && Object.keys(response).length > 0);
                        // Update the user interface, refresh the data list, etc.
                        if (typeof response === 'object' && response !== null && Object.keys(response).length > 0 && response.id) {
                            props.handleActionResponse('poicreatetrue');
                            handleDialogSaveAssessment(response.id, addAssessmentItem);
                            handleIndex(response);
                            resetField();
                            handleDialogClose();
                        } else {
                            if (response instanceof Error) {
                                console.error('Error creating Person Of Interest item:', response);
                                props.handleActionResponse('error', response.message);
                                handleDialogClose();
                                resetField();
                            } else if (typeof response === 'string') {
                                // Handle string response
                                console.error('Error creating Person Of Interest item:', response);

                                // Check for the specific message about POI already existing
                                if (response === "The POI you are trying to create, already exists in the system") {
                                    // Use poicreateexist code to display the user-friendly message
                                    props.handleActionResponse('poicreateexist');
                                } else {
                                    // For other string errors, pass them as is
                                    props.handleActionResponse('error', response);
                                }

                                handleDialogClose();
                                resetField();
                            } else {
                                console.error('Error creating Person Of Interest item:', response);
                                props.handleActionResponse('poieditfalse');
                                handleDialogClose();
                                resetField();
                            }
                        }
                    }).catch((error) => {
                        // If there is an error during update, handle it
                        console.error('Error Creating Person Of Interest item:', error);

                        // Try to extract a meaningful error message if possible
                        if (error instanceof Error) {
                            props.handleActionResponse('error', error.message);
                        } else if (typeof error === 'string') {
                            props.handleActionResponse('error', error);
                        } else {
                            // Fall back to generic error if we can't extract a specific message
                            props.handleActionResponse('poicreatefalse');
                        }

                        handleDialogClose();
                        resetField();
                    });
                }
            }
        }
    };

    const handleIndex = (poi: any) => {
        ConvertForIndex(poi, auth.user?.id_token).then((response) => {
            if (typeof response === 'object' && Object.keys(response).length > 0)
                UpdateIndexRecord(response, auth.user?.id_token);
        })
    }

    const handleDialogSaveAssessment = (pId: number, item: AssessmentItem) => {
        if (item.dateOfAssessment === null || item.dateOfAssessment === undefined || item.dateOfAssessment === '') {
            setError('Add Date of assessment');
        } else if (item.euSectoralLegislatureBasisId === null || item.euSectoralLegislatureBasisId === undefined) {
            setError('Add EU sectoral legislative basis');
        } else if (!validateObject(item)) {
            const invalidChars = getFormattedInvalidCharacters();
            setError(`Illegal HTML content - please remove any of the following special characters: ${invalidChars}`);
        } else {
            item.assessingCAId = userInfo.ncaCode;
            item.personId = pId;
            Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == null && delete item[k as keyof AssessmentItem]);
            Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == undefined && delete item[k as keyof AssessmentItem]);
            Object.keys(item).forEach((k) => item[k as keyof AssessmentItem] == "" && delete item[k as keyof AssessmentItem]);
            CreateAssessment(item, auth.user?.id_token).then((response) => {
                // Successful create, handle the response accordingly
                console.log('Assessment item created successfully:', response);
                // props.handleActionResponse('assesscreatetrue');
                // Update the user interface, refresh the data list, etc.
            }).catch((error) => {
                // If there is an error during update, handle it
                console.error('Error creating Assessment item:', error);

                let fallbackMessage = strings.assessmentDefaultErrorMessage;
                let serverErrorMessage = fallbackMessage;

                if (error instanceof EIOPAError) {
                    const rawMessage = error.message;

                    if (rawMessage === 'The Assessment you are trying to create, already exists in the system') {
                        serverErrorMessage = "assesscreateexist";
                        props.handleActionResponse(serverErrorMessage);
                        return;
                    } else {
                        try {
                            const parsed = JSON.parse(rawMessage);
                            if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                serverErrorMessage = parsed.errors[0];
                                props.handleActionResponse('error', serverErrorMessage);
                                return;
                            }
                        } catch (parseError) {
                            console.error("Failed to parse EIOPAError message as JSON:", parseError);
                        }
                    }
                } else {
                    try {
                        const parsed = JSON.parse(error.message);
                        if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                            serverErrorMessage = parsed.errors[0];
                            props.handleActionResponse('error', serverErrorMessage);
                            return;
                        }
                    } catch (parseErr) {
                        console.error("Failed to parse error message as JSON:", parseErr);
                    }
                }

                props.handleActionResponse('assesscreatefalse');
            });
        }
    };

    // Dialog Edit POI
    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
        }),
        [],
    );

    let actionDis: boolean = false;
    if (props.item != null) {
        actionDis = true;
    }

    const onChangeDropdown = (event: any, option: any, index: any) => {
        props.setSelectedPersonTypeInDialog(option.key);
        setAddEditItem({ ...initialPOI, personTypeID: option.key });
        setAddAssessmentItem({ ...initialAssessment });
    };

    let SelectedDialog: any;
    switch (props.item?.personTypeID ? props.item.personTypeID : props.selectedPersonTypeInDialog) {
        case NATURAL_PERSON_TYPE:
            SelectedDialog = (
                <Natural
                    addEditItem={addEditItem}
                    setAddEditItem={setAddEditItem}
                    addAssessmentItem={addAssessmentItem}
                    setAddAssessmentItem={setAddAssessmentItem}
                    date={props.dateOfBirth}
                    error={error}
                    dateOfBirthIsValid={setDateOfBirthIsValid}
                    dateOfBirthIsRequired={setDateOfBirthIsRequired}
                    dateOfAssessmentIsValid={setDateOfAssessmentIsValid}
                    showHistoricalFields={showHistoricalFields}
                />
            );
            break;
        case LEGAL_PERSON_TYPE:
            SelectedDialog = (
                <Legal
                    addEditItem={addEditItem}
                    setAddEditItem={setAddEditItem}
                    addAssessmentItem={addAssessmentItem}
                    setAddAssessmentItem={setAddAssessmentItem}
                    error={error}
                    dateOfAssessmentIsValid={setDateOfAssessmentIsValid}
                />
            );
            break;
        default:
            SelectedDialog = <div />;
            break;
    }

    return (
        <div className="POI">
            <form onSubmit={handleSubmit}>
                <Dialog
                    hidden={props.dialogIsHidden}
                    onDismiss={handleDialogClose}
                    dialogContentProps={dialogContentPropsEdit}
                    modalProps={modalPropsEdit}
                    minWidth="560px"
                >
                    {error && (
                        <MessageBar
                            messageBarType={MessageBarType.error}
                            isMultiline={true}
                            dismissButtonAriaLabel="Close"
                            onDismiss={() => setError('')}
                        >
                            {error}
                        </MessageBar>
                    )}
                    <Stack horizontal tokens={stackTokens}>
                        <Dropdown
                            data-testid="type-dropdown-dialog"
                            label="Type"
                            options={type}
                            defaultSelectedKey={props.selectedPersonTypeInDialog}
                            disabled={actionDis}
                            onChange={onChangeDropdown}
                            className={styles.inputFieldFull}
                        />
                    </Stack>
                    {SelectedDialog}
                    <DialogFooter>
                        <PrimaryButton
                            onClick={() => handleDialogSave(addEditItem.id ? addEditItem.id : 0, addEditItem)}
                            text={props.isAdd ? 'Add' : 'Save'}
                        />
                        <DefaultButton
                            onClick={handleDialogClose}
                            text="Cancel" />
                    </DialogFooter>
                </Dialog>
            </form>
        </div>

    );
}

function AddAssessments(props: any) {
    const auth = useAuth();

    const datePickerRef = React.useRef<IDatePicker>(null);
    const [DOAssessment, setDOAssessment] = useState<Date | undefined>(props.date ?? new Date());
    const [type, setType] = React.useState<IDropdownOption[]>([]);
    const [changedDate, setChangedDate] = useState({
        date: new Date(),
        error: false,
        message: ''
    });
    let [DOAString, setDOAString] = useState<string | undefined>(undefined);

    useEffect(() => {
        // Fetch EUSLB data from the API
        (async function () {
            const result = await fetchEUSLB("1", auth.user?.id_token);
            const filteredResult = result.sort((a, b) => a.name.localeCompare(b.name)).filter(item => item.active);

            const newArrayOfObj = filteredResult.map(({
                id: key,
                name: text,
            }) => ({
                key,
                text
            }));
            setType(newArrayOfObj);
        })();
    }, []);

    const onChangeField = (event: any) => {
        props.setAddAssessmentItem({ ...props.addAssessmentItem, [event.target.name]: event.target.value.trim().length > 0 ? event.target.value.trim() : null });
    }

    const onChangeDate = (event: any) => {
        let typedDate = onParseDateFromString(DOAString);
        let dateToChange;
        if (event !== typedDate) {
            dateToChange = event;
        } else {
            dateToChange = typedDate;
        }
        if (DOAString && !typedDate) {
            setDOAssessment(undefined);
            setChangedDate({ ...changedDate, error: true, message: 'Invalid date format' })
            props.setAddAssessmentItem({ ...props.addAssessmentItem, dateOfAssessment: undefined });
            props.dateOfAssessmentIsValid(false);
        } else {
            let date;
            if (!Number.isNaN(Date.parse(dateToChange))) {
                date = new Date(Date.parse(dateToChange));
            }
            let newDate = date === undefined ? undefined : new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            setDOAssessment(newDate);
            setChangedDate({ ...changedDate, error: false, message: '' })
            props.setAddAssessmentItem({ ...props.addAssessmentItem, dateOfAssessment: newDate?.toLocaleDateString('fr-BE') });
            props.dateOfAssessmentIsValid(!!newDate);
        }
        setDOAString(undefined)
    }

    let actionDis: boolean = false;
    if (props.item != null) {
        actionDis = true;
    }

    const onChangeDropdown = (event: any, option: any, index: any) => {
        props.setAddAssessmentItem({ ...props.addAssessmentItem, euSectoralLegislatureBasisId: option.key });
    };
    const onParseDateFromString = (newValue: string | undefined): Date | null => {
        if (newValue) {
            const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
            if (dateRegex.test(newValue)) {
                const newValueParts = newValue.trim().split('/');
                const day = Math.max(1, Math.min(31, Number.parseInt(newValueParts[0], 10)));
                const month = Math.max(1, Math.min(12, Number.parseInt(newValueParts[1], 10))) - 1;
                let year = Number.parseInt(newValueParts[2], 10);
                let isFutureDate = new Date(year, month, day) > new Date();
                setChangedDate({ ...changedDate, date: new Date(year, month, day), error: isFutureDate, message: isFutureDate ? 'Future dates are not permitted' : '' })
                props.dateOfAssessmentIsValid(!isFutureDate);
                return new Date(year, month, day);
            }
        }
        return null;
    }

    let SelectedAssessment: any;
    switch (props.id) {
        case undefined:
            SelectedAssessment = (
                <Stack>
                    <StackItem className={styles.DialogTitleAssessmentDetails}>Assessment details</StackItem>
                    <StackItem>
                        <Stack horizontal tokens={stackTokens}>
                            <StackItem grow={2}>
                                <TextField label={strings.POIListAssessmentIntAssessNo} defaultValue={props.addAssessmentItem.internalCARefNo || ""} name="internalCARefNo" placeholder="Type number" className={styles.inputField} onChange={onChangeField} maxLength={500} />
                            </StackItem>
                            <StackItem grow={2}>
                                <DatePicker
                                    componentRef={datePickerRef}
                                    label={strings.requestForInfoPOIAssessDate}
                                    value={DOAssessment}
                                    placeholder={strings.datepickerPlaceholder}
                                    formatDate={onFormatDate}
                                    className={styles.inputField}
                                    onSelectDate={onChangeDate}
                                    maxDate={new Date()}
                                    textField={{
                                        // @ts-ignore
                                        "data-testid": "dateassessment-dialog",
                                        required: true,
                                        onNotifyValidationResult: (errorMessage, value) => {
                                            setDOAString(value)
                                        },
                                        errorMessage: changedDate.date && changedDate.error ? changedDate.message : !DOAssessment && props.error ? "Field is required" : ""
                                    }}
                                    allowTextInput
                                    parseDateFromString={(dateStr: string) => {
                                        DOAString = dateStr;
                                        return onParseDateFromString(dateStr)
                                    }}
                                    strings={{ ...defaultDatePickerStrings, isOutOfBoundsErrorMessage: "Future dates are not allowed" }}
                                    styles={{
                                        statusMessage: {
                                            display: 'none'
                                        }
                                    }}
                                />
                            </StackItem>
                        </Stack>
                    </StackItem>
                    <Stack horizontal tokens={stackTokens}>
                        <StackItem grow={2}>
                            <Stack horizontal tokens={stackTokens}>
                                <Dropdown
                                    data-testid="euslb-dropdown-dialog"
                                    label={strings.requestForInfoEUSecLegBasis}
                                    options={type}
                                    placeholder={"Select basis"}
                                    defaultSelectedKey={props.addAssessmentItem.euSectoralLegislatureBasisId}
                                    disabled={actionDis}
                                    onChange={onChangeDropdown}
                                    className={styles.inputFieldFull}
                                    required
                                    errorMessage={!props.addAssessmentItem.euSectoralLegislatureBasisId && props.error ? "Field is required" : ""}
                                />
                            </Stack>
                        </StackItem>
                    </Stack>
                </Stack>
            );
            break;
        default:
            SelectedAssessment = (<></>);
            break;
    }
    return SelectedAssessment;
}

function Natural(props: any) {

    const datePickerRef = React.useRef<IDatePicker>(null);
    const [DOBirth, setDOBirth] = useState<Date | undefined>(props.date);
    const [isRequired, setIsRequired] = useState({ required: !props.addEditItem.idNumber && !props.addEditItem.socialSecurityNumber });
    const [changedDate, setChangedDate] = useState({
        date: new Date(),
        error: false,
        message: ''
    });
    let [DOBirthString, setDOBirthString] = useState<string | undefined>(undefined);

    useEffect(() => {
        props.dateOfBirthIsValid(isRequired.required ? !!DOBirth : true);
        props.dateOfBirthIsRequired(isRequired.required);
    }, []);


    const onChangeField = (event: any) => {
        props.setAddEditItem({ ...props.addEditItem, [event.target.name]: event.target.value.trim().length > 0 ? event.target.value.trim() : null });

        if (props.addEditItem.personTypeID == NATURAL_PERSON_TYPE) {
            if (event.target.value.trim() && (event.target.name === 'idNumber' || event.target.name === 'socialSecurityNumber')) {
                setIsRequired({ required: false });
                props.dateOfBirthIsRequired(false);
                props.dateOfBirthIsValid(changedDate.message === '');
            }
            else if (!event.target.value.trim() && (event.target.name === 'idNumber' && !props.addEditItem.socialSecurityNumber)) {
                setIsRequired({ required: true });
                props.dateOfBirthIsRequired(true);
                props.dateOfBirthIsValid(changedDate.message === '' && DOBirth !== undefined);
            }
            else if (!event.target.value.trim() && (event.target.name === 'socialSecurityNumber' && !props.addEditItem.idNumber)) {
                setIsRequired({ required: true });
                props.dateOfBirthIsRequired(true);
                props.dateOfBirthIsValid(changedDate.message === '' && DOBirth !== undefined);
            }
            else if (props.addEditItem.idNumber || props.addEditItem.socialSecurityNumber) {
                setIsRequired({ required: false });
                props.dateOfBirthIsRequired(false);
                props.dateOfBirthIsValid(changedDate.message === '');
            }
        }
    }

    const onChangeDate = (event: any) => {
        let typedDate = onParseDateFromString(DOBirthString);
        let dateToChange;
        if (event !== typedDate) {
            dateToChange = event;
        } else {
            dateToChange = typedDate;
        }
        if (DOBirthString && !typedDate) {
            setDOBirth(undefined);
            setChangedDate({ ...changedDate, error: true, message: 'Invalid date format' })
            props.dateOfBirthIsValid(false);
            props.setAddEditItem({ ...props.addEditItem, dateOfBirth: undefined });
        } else {
            let date;
            if (!Number.isNaN(Date.parse(dateToChange))) {
                date = new Date(Date.parse(dateToChange));
            }
            let newDate = date === undefined ? undefined : new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            setDOBirth(newDate);
            setChangedDate({ ...changedDate, error: false, message: '' })
            props.dateOfBirthIsValid(isRequired.required ? !!newDate : true);
            props.setAddEditItem({ ...props.addEditItem, dateOfBirth: newDate?.toLocaleDateString('fr-BE') });
        }
        setDOBirthString(undefined)
    }


    const onParseDateFromString = (newValue: string | undefined): Date | null => {
        if (newValue) {
            const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
            if (dateRegex.test(newValue)) {
                const newValueParts = newValue.trim().split('/');
                const day = Math.max(1, Math.min(31, Number.parseInt(newValueParts[0], 10)));
                const month = Math.max(1, Math.min(12, Number.parseInt(newValueParts[1], 10))) - 1;
                let year = Number.parseInt(newValueParts[2], 10);
                let isFutureDate = new Date(year, month, day) > new Date();
                props.dateOfBirthIsValid(!isFutureDate);
                setChangedDate({ ...changedDate, date: new Date(year, month, day), error: isFutureDate, message: isFutureDate ? 'Future dates are not permitted' : '' })
                return new Date(year, month, day);
            }
        }
        return null;
    }

    return (
        <div>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField data-testid="first-name-dialog" label={strings.requestForInfoPOIFirstName} defaultValue={props.addEditItem.firstName || ""} name="firstName" placeholder="Type name" className={styles.inputField} onChange={onChangeField} maxLength={500} required errorMessage={!props.addEditItem.firstName && props.error ? "Field is required" : ""} />
                </StackItem>
                <StackItem grow={2}>
                    <TextField data-testid="last-name-dialog" label={strings.requestForInfoPOILastName} defaultValue={props.addEditItem.lastName || ""} name="lastName" placeholder="Type name" className={styles.inputField} onChange={onChangeField} maxLength={500} required errorMessage={!props.addEditItem.lastName && props.error ? "Field is required" : ""} />
                </StackItem>
            </Stack>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField data-testid="aka-dialog" label={strings.requestForInfoPOIAlsoKnownAs} defaultValue={props.addEditItem.alsoKnownAs || ""} name="alsoKnownAs" placeholder="Type name" className={styles.inputField} maxLength={500} onChange={onChangeField} />
                </StackItem>
                <StackItem grow={2}>
                    <DatePicker
                        componentRef={datePickerRef}
                        label={strings.dateOfBirthLabel}
                        value={DOBirth}
                        placeholder={strings.datepickerPlaceholder}
                        formatDate={onFormatDate}
                        className={styles.inputField}
                        onSelectDate={onChangeDate}
                        maxDate={new Date()}
                        textField={{
                            // @ts-ignore
                            "data-testid": "dateofbirth-dialog",
                            required: isRequired.required,
                            onNotifyValidationResult: (errorMessage, value) => {
                                setDOBirthString(value)
                            },
                            errorMessage: changedDate.date && changedDate.error ? changedDate.message : !DOBirth && isRequired.required && props.error ? "Field is required" : ""
                        }}
                        allowTextInput
                        parseDateFromString={(dateStr: string) => {
                            DOBirthString = dateStr;
                            return onParseDateFromString(dateStr)
                        }}
                        strings={{ ...defaultDatePickerStrings, isOutOfBoundsErrorMessage: "Future dates are not allowed" }}
                        styles={{
                            statusMessage: {
                                display: 'none'
                            }
                        }}
                    />
                </StackItem>
            </Stack>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField data-testid="countryofbirth-dialog" label={strings.requestForInfoPOIPlaceOfBirth} defaultValue={props.addEditItem.countryOfBirth || ""} name="countryOfBirth" placeholder="Type country" className={styles.inputField} onChange={onChangeField} maxLength={500} {...isRequired} errorMessage={!props.addEditItem.countryOfBirth && isRequired.required === true && props.error ? "Field is required" : ""} />
                </StackItem>
                <StackItem grow={2}>
                    <Label styles={{ root: { color: 'transparent' } }}>&nbsp;</Label>
                    <TextField data-testid="cityofbirth-dialog" defaultValue={props.addEditItem.cityOfBirth || ""} name="cityOfBirth" placeholder="Type city" className={styles.inputField} onChange={onChangeField} maxLength={500} errorMessage={!props.addEditItem.cityOfBirth && isRequired.required === true && props.error ? "Field is required" : ""} />
                </StackItem>
            </Stack>
            {props.showHistoricalFields && (
                <Stack horizontal tokens={stackTokens}>
                    <StackItem grow={2}>
                        <TextField data-testid="idnumber-dialog" label={strings.POIListIDNumber} defaultValue={props.addEditItem.idNumber || ""} name="idNumber" placeholder="Type number" className={styles.inputField} onChange={onChangeField} maxLength={500} onRenderLabel={onRenderLabelHandleIDNo} />
                    </StackItem>
                    <StackItem grow={2}>
                        <TextField data-testid="ssn-dialog" label={strings.POIListSocialSecurityNumber} defaultValue={props.addEditItem.socialSecurityNumber || ""} name="socialSecurityNumber" placeholder="Type number" className={styles.inputField} onChange={onChangeField} maxLength={500} onRenderLabel={onRenderLabelHandleSSN} />
                    </StackItem>
                </Stack>
            )}
            <AddAssessments addAssessmentItem={props.addAssessmentItem} setAddAssessmentItem={props.setAddAssessmentItem} date={props.dateOfAssessment} id={props.addEditItem.id} error={props.error} dateOfAssessmentIsValid={props.dateOfAssessmentIsValid} />
        </div>
    );
}

function Legal(props: any) {

    const onChangeField = (event: any) => {
        props.setAddEditItem({ ...props.addEditItem, [event.target.name]: event.target.value.trim().length > 0 ? event.target.value.trim() : null });
    }

    return (
        <div>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField data-testid="legal-name-dialog" label={strings.legalNameLabel} defaultValue={props.addEditItem.legalName || ""} name="legalName" placeholder="Type name" className={styles.inputField} onChange={onChangeField} maxLength={500} required errorMessage={!props.addEditItem.legalName && props.error ? "Field is required" : ""} />
                </StackItem>
                <StackItem grow={2}>
                    <TextField data-testid="aka-dialog" label={strings.requestForInfoPOIAlsoKnownAs} defaultValue={props.addEditItem.alsoKnownAs || ""} name="alsoKnownAs" placeholder="Type name" className={styles.inputField} onChange={onChangeField} maxLength={500} />
                </StackItem>
            </Stack>
            <Stack horizontal tokens={stackTokens}>
                <StackItem grow={2}>
                    <TextField data-testid="lei-dialog" label={strings.leiRegistrationNumberLabel} defaultValue={props.addEditItem.leI_Registration || ""} name="leI_Registration" placeholder="Type number" className={styles.inputField} onChange={onChangeField} maxLength={500} required errorMessage={!props.addEditItem.leI_Registration && props.error ? "Field is required" : ""} />
                </StackItem>
                <StackItem grow={2}>
                    <TextField data-testid="countryinc-dialog" label={strings.countryOfIncorporationLabel} defaultValue={props.addEditItem.countryInc || ""} name="countryInc" placeholder="Type country" className={styles.inputField} onChange={onChangeField} maxLength={500} />
                </StackItem>
            </Stack>
            <AddAssessments addAssessmentItem={props.addAssessmentItem} setAddAssessmentItem={props.setAddAssessmentItem} date={props.dateOfAssessment} id={props.addEditItem.id} error={props.error} dateOfAssessmentIsValid={props.dateOfAssessmentIsValid} />
        </div>
    );
}

export default AddEditDialog;
